// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq2_faq__LxaGH"};